<template>
  <GroupMasterLayout>
    <!-- FIRST SECTION -->
    <section class="overhead">
      <div class="overhead-1 row justify-content-between py-5 wallet-header">
        <div class="col-sm-12 col-md-6">
          <h5 class="">{{ $t("text.iGroup.orderManagement") }}</h5>

          <h6>{{ $t("text.iGroup.cumulativeDetails") }}</h6>
        </div>
        <div class="col-md-4 col-sm-12 date_picker_m">
          <div class="">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              color="#370F70"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="bg-white rounded table-section">
      <ejs-grid
        v-show="!showLoader"
        ref="dataGrid"
        :created="refreshGrid"
        :allowPaging="true"
        :allowSorting="true"
        :pageSettings="pageSettings"
        :toolbar="toolbar"
        :searchSettings="search"
        :allowExcelExport="true"
        :allowPdfExport="true"
        :toolbarClick="toolbarClick"
        :locale="usedLang"
      >
        <e-columns>
          <e-column width="40" field="index" headerText="#"></e-column>
          <e-column
            field="branchName"
            width="180"
            :headerText="$t('text.iBranchTank.site')"
          ></e-column>
          <e-column
            field="totalOrderQuantity"
            width="180"
            :headerText="$t('text.iGroup.totalOrder')"
          ></e-column>
          <e-column
            field="totalOrder"
            width="180"
            :headerText="$t('text.iGroup.quantity')"
          ></e-column>
          <e-column
            field="totalOrderAmount"
            width="180"
            :headerText="$t('text.iGroup.amount')"
          ></e-column>

          <e-column
            :template="orderAction"
            width="180"
            :headerText="$t('text.actionButtons.title')"
          ></e-column>
        </e-columns>
      </ejs-grid>
      <TableLoader :showLoader="showLoader" />
    </section>
  </GroupMasterLayout>
</template>

<script>
import GroupMasterLayout from "@/views/Industrial/GroupMasterLayout.vue";
import TableLoader from "@/components/tableLoader/index";
import configObject from "@/config";
import OrderActions from "@/components/TableTemplates/IndustrialAdmin/orderMGTGroup.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

export default {
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      showLoader: true,
      groupID: localStorage.getItem("groupID")
        ? localStorage.getItem("groupID")
        : null,
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      orderAction: function () {
        return {
          template: OrderActions,
        };
      },
    };
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getOrderMGT();
      }
    },
  },
  components: {
    GroupMasterLayout,
    TableLoader,
  },
  created() {
    this.getOrderMGT();
  },
  methods: {
    getOrderMGT() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Group/Orders/${this.groupID}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          console.log(res.data);
          let index = 0;
          res.data.forEach((el) => {
            index++;
            el.index = index;
            el.totalOrderQuantity = el.totalOrderQuantity.toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            );
            el.totalOrderAmount = el.totalOrderAmount.toLocaleString(
              undefined,
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            );
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          console.log(res);
        });
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>

<style scoped>
.wallet-header {
  width: 90%;
  margin: auto auto;
}

.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}

.overhead ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}

.sub-nav li {
  color: #2b2b2b;
  font-size: 14px;
  cursor: pointer;
}

.active-nav {
  color: #370f70 !important;
  border-bottom: 2px solid #370f70;
}

.sub-nav {
  width: 98%;
  margin: auto auto;
  border-bottom: 1px solid rgba(98, 98, 98, 0.2);
}

.table-section {
  width: 95%;
  margin: auto auto;
  height: 400px;
}

@media only screen and (max-width: 600px) {
  .new_card {
    display: block;
    width: 100%;
  }
  .first-section {
    flex-direction: column;
  }
}
</style>
